import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SafeheirLogo from '../components/SafeheirLogo';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.firstName.trim()) { setError('Le prénom est obligatoire'); return; }
    if (!formData.lastName.trim()) { setError('Le nom de famille est obligatoire'); return; }
    if (!formData.email.trim()) { setError("L'email est obligatoire"); return; }
    if (formData.password.length < 8) { setError('Le mot de passe doit contenir au moins 8 caractères'); return; }
    if (formData.password !== formData.confirmPassword) { setError('Les mots de passe ne correspondent pas'); return; }

    setLoading(true);
    try {
      const result = await register(formData.email, formData.password, formData.firstName, formData.lastName);
      if (result.success) {
        // Déverrouillage MK effectué à l'entrée d'OnboardingPage (T-K06-01a).
        // Register ne peut pas garantir unlockVault avant vérification email (DEC-011).
        navigate('/verify-email', { state: { email: formData.email } });
      } else {
        setError(result.error || "Erreur lors de l'inscription");
        setLoading(false);
      }
    } catch {
      setError("Erreur lors de l'inscription. Veuillez réessayer.");
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    boxSizing: 'border-box',
    padding: '10px 14px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8,
    color: '#fff',
    fontSize: 14,
    outline: 'none',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0A1628',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>

        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <SafeheirLogo size="lg" />
          </Link>
          <h1 style={{ margin: '1.5rem 0 0.4rem', fontSize: '1.5rem', fontWeight: 700, color: '#fff' }}>Créer un compte</h1>
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.45)', fontSize: '0.9rem' }}>
            Transmettez vos accès numériques en toute sécurité
          </p>
        </div>

        <div style={{
          background: 'rgba(10,22,40,0.7)',
          backdropFilter: 'blur(20px)',
          borderRadius: 16,
          padding: '2rem',
          border: '1px solid rgba(255,255,255,0.07)',
        }}>
          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.12)',
              border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: 8,
              padding: '10px 14px',
              marginBottom: 20,
              color: '#f87171',
              fontSize: 14,
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 6 }}>Prénom *</label>
                <input
                  type="text" name="firstName" required autoComplete="given-name"
                  value={formData.firstName} onChange={handleChange}
                  placeholder="ex: Marie" style={inputStyle}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 6 }}>Nom *</label>
                <input
                  type="text" name="lastName" required autoComplete="family-name"
                  value={formData.lastName} onChange={handleChange}
                  placeholder="ex: Dupont" style={inputStyle}
                />
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 6 }}>Adresse email</label>
              <input
                type="email" name="email" required autoComplete="email"
                value={formData.email} onChange={handleChange}
                placeholder="votre@email.com" style={inputStyle}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 6 }}>
                Mot de passe{' '}
                <span style={{ color: 'rgba(255,255,255,0.3)', fontWeight: 400 }}>(8 caractères minimum)</span>
              </label>
              <input
                type="password" name="password" required autoComplete="new-password"
                value={formData.password} onChange={handleChange}
                placeholder="••••••••" style={inputStyle}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 6 }}>Confirmer le mot de passe</label>
              <input
                type="password" name="confirmPassword" required autoComplete="new-password"
                value={formData.confirmPassword} onChange={handleChange}
                placeholder="••••••••" style={inputStyle}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 4 }}>
              <input
                id="terms" type="checkbox" required
                style={{ marginTop: 2, flexShrink: 0, accentColor: '#00F5A0' }}
              />
              <label htmlFor="terms" style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
                J'accepte les{' '}
                <Link to="/legal/cgu" target="_blank" style={{ color: '#00F5A0', textDecoration: 'none' }}>
                  conditions d'utilisation
                </Link>
                {' '}et la{' '}
                <Link to="/legal/confidentialite" target="_blank" style={{ color: '#00F5A0', textDecoration: 'none' }}>
                  politique de confidentialité
                </Link>.
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: 6,
                width: '100%',
                padding: '11px 0',
                background: '#00F5A0',
                color: '#0A1628',
                border: 'none',
                borderRadius: 8,
                fontWeight: 700,
                fontSize: 14,
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Création du compte...' : 'Créer mon compte'}
            </button>
          </form>
        </div>

        <div style={{ marginTop: '1.25rem', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
          <Link to="/login" style={{ color: '#00F5A0', textDecoration: 'none', fontSize: '0.875rem' }}>
            Déjà un compte ? Se connecter
          </Link>
          <Link to="/" style={{ color: 'rgba(255,255,255,0.35)', textDecoration: 'none', fontSize: '0.875rem' }}>
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
